/* 🤖 this file was generated by svg-to-ts*/
export const icoChartPieFilled: {
  name: 'chart-pie-filled';
  data: string;
} = {
  name: 'chart-pie-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 2.051V11h8.949c-.47-4.717-4.232-8.479-8.949-8.949zm4.969 17.953c2.189-1.637 3.694-4.14 3.98-7.004h-8.183l4.203 7.004z" fill="#909090"/><path d="M11 12V2.051C5.954 2.555 2 6.824 2 12c0 5.514 4.486 10 10 10a9.93 9.93 0 004.255-.964s-5.253-8.915-5.254-9.031A.02.02 0 0011 12z" fill="#909090"/></svg>`
};
